/*
 * Copyright 2023 Beeper Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *         http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { IWidgetApiRequest, IWidgetApiRequestData } from "./IWidgetApiRequest";
import { WidgetApiFromWidgetAction } from "./WidgetApiAction";
import { IWidgetApiResponseData } from "./IWidgetApiResponse";
import { IRoomAccountData } from "./IRoomAccountData";
import { Symbols } from "../Symbols";

export interface IReadRoomAccountDataFromWidgetRequestData extends IWidgetApiRequestData {
    type: string;
    room_ids?: Symbols.AnyRoom | string[]; // eslint-disable-line camelcase
}

export interface IReadRoomAccountDataFromWidgetActionRequest extends IWidgetApiRequest {
    action: WidgetApiFromWidgetAction.BeeperReadRoomAccountData;
    data: IReadRoomAccountDataFromWidgetRequestData;
}

export interface IReadRoomAccountDataFromWidgetResponseData extends IWidgetApiResponseData {
    events: IRoomAccountData[];
}

export interface IReadRoomAccountDataFromWidgetActionResponse extends IReadRoomAccountDataFromWidgetActionRequest {
    response: IReadRoomAccountDataFromWidgetResponseData;
}
